<template>
  <div class="homepage">
    <div class="home_bottom">
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="chart_box nave_title">
            <div>
              <div class="wel_come">
                {{ getTimeState() }} {{ userName }}。
              </div>
              <div class="time_now">
                最近登录时间：{{ timeNow }}
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- <el-row :gutter="20">
        <el-col :span="7">
          <div class="chart_box">
            <div class="tit_bar"><i class="el-icon-tickets"></i> 各项指标近期数据</div>
            <div class="tit_bar_small">小区/社区/总数据/今日数据</div>
            <div class="tit_bar_small">指标的总数据和今日数据</div>
          </div>
        </el-col>
        <el-col :span="7">
          <quill-editor v-model:content="content" contentType="html"  :options="editorOptions"></quill-editor>
          <button @click="dianjishijian">保存数据</button>
        </el-col>
      </el-row> -->
    </div>
  </div>
</template>

<script>
// 引入富文本编辑器与样式
// import { Quill, QuillEditor } from '@vueup/vue-quill'
// import '@vueup/vue-quill/dist/vue-quill.snow.css'
import { QuillEditor } from '@vueup/vue-quill';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
var moment = require("moment");
export default {
  name: "dashboard",
  components: { QuillEditor },
  data() {
    return {
      content: "",
      editorOptions: {
        theme: 'snow', // 设置主题，可选值有'snow'、'bubble'等
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'], // 定义工具栏上的按钮，这里是一些基本的文本格式按钮
            ['blockquote', 'code-block'],
            ['link', 'image', 'video'],
            ['clean']
          ]
        }
      }
    };
  },
  computed: {},
  created() { },
  mounted() {

  },
  methods: {
    dianjishijian(){
      console.log(typeof this.content,"============")
    },
    getTimeState() {
      // 获取当前时间
      let timeNow = new Date();
      // 获取当前小时
      let hours = timeNow.getHours();
      // 设置默认文字
      let state = ``;
      // 判断当前时间段
      if (hours >= 0 && hours <= 10) {
        state = `早上好!`;
      } else if (hours > 10 && hours <= 14) {
        state = `中午好!`;
      } else if (hours > 14 && hours <= 18) {
        state = `下午好!`;
      } else if (hours > 18 && hours <= 24) {
        state = `晚上好!`;
      }
      return state;
    },
    formatTime() {
      let date = new Date();
      this.timeNow = moment(date).format("YYYY-MM-DD HH:mm");
    },

  },
};
</script>

<style lang="scss" scoped>
.info_box {
  margin: 15px;
}

.data_box {
  margin-bottom: 25px;
}

.data-card {
  border: 1px solid #f1f1f1;
  background-color: #fff;

  .tit {
    font-size: 14px;
    font-weight: 500;
    padding: 10px;
    display: flex;
    color: #17233d;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #f1f1f1;
  }

  .data-main {
    padding: 20px;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-direction: column;
    border-bottom: 1px solid #f1f1f1;

    .big {
      font-size: 30px;
    }

    .users {
      padding-left: 10px;

      .img {
        display: block;
        border-radius: 50%;
        float: left;
        margin-left: -10px;

        img {
          width: 30px;
          height: 30px;
          border: 1px solid #fff;
          border-radius: 50%;
        }
      }
    }

    p {
      line-height: 30px;
      color: #787878;
    }
  }

  .meta {
    padding: 10px;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.data-card:hover {
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.08);
}

.homepage {
  margin: 15px;

  .tit_bar {
    font-size: 16px;
    color: #4f5a6c;
    border-bottom: 1px solid #f1f1f1;
    margin-bottom: 15px;
    padding-bottom: 10px;

    i {
      color: #ff445d;
    }
  }

  .tit_bar_small {
    font-size: 13px;
    color: #4f5a6c;
    margin-bottom: 15px;
    padding-bottom: 10px;
  }

  .pingan_box_list {
    padding-top: 10px;
    display: flex;
    justify-content: space-between;

    .select_pingan_box {
      border: 1px solid #0095ff;
    }

    .select_pingan_box_o {
      border: 1px solid #f1f1f1;
    }

    .pingan_box {
      cursor: pointer;
      width: 200px;
      height: 90px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      p {
        font-size: 20px;
        font-weight: bold;
      }

      span {
        font-size: 14px;
      }
    }
  }

  .one_list {
    display: flex;
    flex-wrap: wrap;
    margin-left: 10px;

    .one_list_box {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      // margin-right: 30px;
      width: 200px;

      img {
        width: 40px;
        margin-right: 10px;
      }

      .one_list_text {
        font-size: 14px;

        span {
          font-size: 22px;
          font-weight: 700;
          margin: 0 5px;
        }
      }
    }
  }

  .six_list_box {
    display: flex;
    flex-wrap: wrap;
    margin-left: 10px;

    .six_box {
      margin-bottom: 20px;

      .six_box_title {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
        width: 200px;

        img {
          width: 30px;
          height: auto;
          margin-right: 10px;
        }

        .title_name {
          font-size: 16px;
        }
      }

      .six_box_main {
        .six_box_text {
          font-size: 14px;

          span {
            font-size: 22px;
            font-weight: 700;
            margin: 0 5px;
          }
        }
      }
    }
  }
}

.home_bottom {
  margin-bottom: 30px;

  .nave_title {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .chart_box {
    padding: 10px;
    border: 1px solid #ebeef5;
    border-radius: 3px;
    background-color: #fff;

    .wel_come {
      font-size: 24px;
      font-weight: bold;
    }

    .time_now {
      margin-top: 5px;
      font-size: 13px;
      color: #999999;
    }
  }

  .chart_box:hover {
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  }

  .news_box {
    p {
      font-size: 16px;
      line-height: 35px;

      a {
        color: #4f5a6c;
      }

      a:hover {
        color: #ff445d;
      }

      i {
        font-size: 12px;
        padding-right: 10px;
        color: #f47004;
      }
    }
  }
}
</style>
